const INITIAL_STATE = {
  hasAccess: false,
  accessTrigger: false,
  isLoading: true,
  error: null,
  whatsapp: "",
  unlimitedImages: false,
  generatedImages: [],
  generatedImagesLoaded: false,
  remainingAttempts: 0,
  mediaKit: [],
  mediaKitLoaded: false,
  reportData: [],
  pageInfo: null,
  reportError: false,
};

const reducer = (state = INITIAL_STATE, action) => {
  const { payload } = action;
  switch (action.type) {
    case "AI_CREATOR_ACCESS":
      return {
        ...state,
        isLoading: true,
      };

    case "AI_CREATOR_GET_GENERATED_IMAGES":
      return {
        ...state,
        isLoading: true,
        generatedImages: [],
        generatedImagesLoaded: false,
      };

    case "AI_CREATOR_ACCESS_SUCCESS":
      return {
        ...state,
        hasAccess: payload.hasAccess,
        whatsapp: payload.whatsapp,
        unlimitedImages: payload.unlimitedImages,
        isLoading: false,
        accessTrigger: true,
      };

    case "AI_CREATOR_ACCESS_FAILURE":
      return {
        ...state,
        hasAccess: false,
        whatsapp: "",
        unlimitedImages: false,
        error: payload,
        isLoading: false,
        accessTrigger: true,
      };

    case "AI_CREATOR_GET_GENERATED_IMAGES_SUCCESS": {
      return {
        ...state,
        generatedImages: payload.generatedImages.map((url, i) => {
          return {
            id: i,
            src: url,
          };
        }),
        generatedImagesLoaded: true,
        remainingAttempts: payload.remainingAttempts,
        isLoading: false,
      };
    }

    case "AI_CREATOR_GET_GENERATED_IMAGES_FAILURE": {
      return {
        ...state,
        error: payload,
        isLoading: false,
        generatedImagesLoaded: false,
      };
    }

    case "UPDATE_REMAINING_ATTEMPTS": {
      return {
        ...state,
        remainingAttempts: payload.number,
      };
    }

    case "FINAL_MEDIA_KIT": {
      return {
        ...state,
        mediaKit: payload.dataUrls,
        mediaKitLoaded: true,
      };
    }

    case "GET_MEDIA_KIT_SUCCESS": {
      return {
        ...state,
        mediaKit: payload.dataUrls,
        mediaKitLoaded: true,
      };
    }

    case "GET_MEDIA_KIT_FAILURE": {
      return {
        ...state,
        mediaKit: [],
        mediaKitLoaded: true,
      };
    }

    case "GET_MEDIA_KIT_REPORT_SUCCESS": {
      return {
        ...state,
        reportData: payload.data,
        pageInfo: payload.pageInfo,
      };
    }

    case "GET_MEDIA_KIT_REPORT_FAILURE": {
      return {
        ...state,
        reportData: [],
        pageInfo: null,
        reportError: true,
      };
    }

    case "UPDATE_MEDIA_KIT_STATUS": {
      return {
        ...state,
        reportData: state.reportData.map((item) =>
          item.opportunityId === payload.opportunityId
            ? {
              ...item,
              created: payload.created,
              origin: payload.origin,
            } : item
        ),
      };
    }

    case "RESET_CREATOR_AI_SUCCESS":
      return {
        ...INITIAL_STATE,
      };

    default:
      return state;
  }
};

export default reducer;
